import { createContext } from 'react';
import { Analytics } from './Analytics';

export const AnalyticsContext = createContext<Analytics | undefined>(undefined);